const AnnotationType = Object.freeze({
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
})

export default AnnotationType